// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".logo-size{width:4rem;height:4rem}.signature{width:7rem !important;height:5rem}.phoneNumber{direction:ltr}\n", "",{"version":3,"sources":["/app/src/component/common/salesInvoice/factore.scss"],"names":[],"mappings":"AAAA,WACE,UAAW,CACX,WAAY,CACb,WAEC,qBAAsB,CACtB,WAAY,CACb,aAEC,aAAc","file":"factore.scss","sourcesContent":[".logo-size {\n  width: 4rem;\n  height: 4rem;\n}\n.signature {\n  width: 7rem !important;\n  height: 5rem;\n}\n.phoneNumber{\n  direction: ltr;\n}"]}]);
// Exports
module.exports = exports;
